import script from "./Page19.vue?vue&type=script&setup=true&lang=js"
export * from "./Page19.vue?vue&type=script&setup=true&lang=js"

import "./Page19.vue?vue&type=style&index=0&id=84ec5432&lang=less"

const __exports__ = script;

export default __exports__